import { useState, useEffect } from "react"
import { WizardStep } from "../../ui/wizard"
import { NeutralButton } from "../../common/Buttons"
import { createListCollection } from "@chakra-ui/react"
import {
  SelectContent,
  SelectItem,
  SelectRoot,
  SelectTrigger,
  SelectValueText,
} from "../../ui/select"
import { Radio, RadioGroup } from "../../ui/radio"
import { colors } from "../../../utilities/colors"
import AuditUnitDetails from "./AuditUnitDetails"
import auditConditionEnum from "../../../constants/auditConditionEnum"
import { conditionColors, canRefloor, isMaxRefloored } from "../../../utilities/auditUtilities"
import DatePicker from "react-datepicker"

export default function AuditUnitCondition({ auditUnit, auditData, setAuditData, nextStep }) {
  const [formValues, setFormValues] = useState({
    condition: [auditData.condition],
    can_refloor: auditData.can_refloor,
    current_sold: auditData.current_sold,
    current_date_sold: auditData.current_date_sold
  })

  useEffect(() => {
    setFormValues({
      condition: [auditData.condition],
      can_refloor: auditData.can_refloor,
      current_sold: auditData.current_sold,
      current_date_sold: auditData.current_date_sold
    })
  }, [auditData])

  const selectOptions = createListCollection({
    items: Object.keys(auditConditionEnum).map((condition) =>
      ({ label: auditConditionEnum[condition], value: condition })
    )
  })

  const handleNextStep = () => {
    setAuditData({
      ...auditData,
      condition: formValues.condition[0],
      can_refloor: formValues.can_refloor,
      current_sold: formValues.current_sold,
      current_date_sold: formValues.current_date_sold,
      images: formValues.current_sold === '1' && auditUnit.sold !== 2
        ? { 'Bill of Sale (BOS)': null, ...auditData.images }
        : auditData.images
    })
    nextStep()
  }

  return (
    <WizardStep>
      <div className="flex flex-col items-center w-full h-full">
        <div className="flex flex-col items-center justify-between w-full md:w-4/5 h-full pt-6 px-2">
          <AuditUnitDetails auditUnit={auditUnit} />

          <div className="flex flex-col items-center w-full px-2">
            <div className='flex flex-col items-center w-full m-2'>
              <h1 className="text-2xl font-bold">Unit Condition</h1>
              <SelectRoot
                collection={selectOptions}
                size="sm"
                positioning={{ sameWidth: true, placement: "bottom" }}
                value={formValues.condition}
                onValueChange={(e) => setFormValues({
                  ...formValues,
                  condition: e.value,
                  can_refloor: canRefloor(e.value[0], auditUnit)
                })}
              >
                <SelectTrigger
                  borderWidth={2}
                  borderColor={colors.grey}
                  _focus={{ borderColor: colors.grey300 }}
                  rounded="md"
                  p={2}
                >
                  <SelectValueText placeholder="Select Condition">
                    {(items) => items.map((item) => (
                      <span key={item.value} className={conditionColors(item.value)}>
                        {item.label}
                      </span>
                    ))}
                  </SelectValueText>
                </SelectTrigger>
                <SelectContent portalled={false} width="full">
                  {selectOptions.items.map((option) => (
                    <SelectItem key={option.value} item={option} py={3}>
                      <span className={conditionColors(option.value)}>{option.label}</span>
                    </SelectItem>
                  ))}
                </SelectContent>
              </SelectRoot>
            </div>

            {(formValues.condition[0] === '2' && !isMaxRefloored(auditUnit)) &&
              <div className='flex flex-col items-center w-full m-2'>
                <h1 className="text-2xl font-bold mb-1">Can Refloor?</h1>
                <RadioGroup
                  value={formValues.can_refloor}
                  onValueChange={(e) => setFormValues({
                    ...formValues,
                    can_refloor: e.value
                  })}
                  display="flex"
                  gap={10}
                >
                  <Radio value="1">Yes</Radio>
                  <Radio value="0">No</Radio>
                </RadioGroup>
              </div>
            }

              <div className='flex flex-col items-center w-full m-2'>
                <h1 className="text-2xl font-bold mb-1">Has Unit Been Sold?</h1>
                <RadioGroup
                  value={formValues.current_sold}
                  onValueChange={(e) => setFormValues({
                    ...formValues,
                    current_sold: e.value
                  })}
                  display="flex"
                  gap={10}
                >
                  <Radio value="1">Yes</Radio>
                  <Radio value="2">No</Radio>
                </RadioGroup>
              </div>

              {formValues.current_sold !== '2' &&
                <div className="flex flex-col justify-center items-center w-full m-2">
                  <label className="text-2xl text-grey-100">Date Sold</label>
                  <DatePicker
                    selected={formValues.current_date_sold}
                    onChange={(date) => setFormValues({
                      ...formValues,
                      current_date_sold: date
                    })}
                    className="px-4 ml-1 bg-black border-2 border-grey focus:border-grey-300 focus:ring-0 rounded"
                  />
                </div>
              }
          </div>

          <NeutralButton
            text="Next"
            onClick={handleNextStep}
            dataTestId="next-button"
            disabled={!formValues.condition[0]}
          />
        </div>
      </div>
    </WizardStep>
  )
}